import { render, staticRenderFns } from "./MarketDropdown.vue?vue&type=template&id=59707352&scoped=true"
import script from "./MarketDropdown.vue?vue&type=script&lang=js"
export * from "./MarketDropdown.vue?vue&type=script&lang=js"
import style0 from "./MarketDropdown.vue?vue&type=style&index=0&id=59707352&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59707352",
  null
  
)

export default component.exports